import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4269af52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Login" }
const _hoisted_2 = { class: "Login_Container" }
const _hoisted_3 = { class: "Login_Wrapper" }
const _hoisted_4 = { class: "Login_Form" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Login_Form_Title" }, "パスワード再設定", -1))
const _hoisted_6 = { class: "error_message" }
const _hoisted_7 = { class: "error_message" }

import { reactive, ref } from "vue";
import { useStore } from "vuex";
import { Notyf } from "notyf";
import axios from "axios";
import { isValidPassword } from "../functions/Validation.js";
import BtnGreen from "../components/atoms/button/BtnGreen.vue";
import InputText from "../components/atoms/Input/InputText.vue";
type PasswordData = typeof passwordData.value;

export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordReset',
  emits: ["toggleGlobalHeader"],
  setup(__props, { emit: __emit }) {

const notyf = new Notyf();

const emit = __emit;
const store = useStore();
emit("toggleGlobalHeader");

const setBaseUrl = () => {
  store.commit("setBaseUrl");
};
setBaseUrl();

//URLからトークン情報を抜き出す
const token = location.search.slice(7);
//ログイン--------------------------------------
const resetPassWord = async () => {
  validateError();
  if (hasError.value) {
    return;
  }
  try {
    const res = await axios.patch(
      `${store.getters["getBaseUrl"]}/account/updatePassword?password=${passwordData.value.newPassword}`,
      "",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    // console.log(res);
    if (res.data === "OK") {
      passwordData.value.currentPassword = "";
      passwordData.value.newPassword = "";
      passwordData.value.newSubPassword = "";
      notyf.success("パスワードを変更しました");
    } else {
      notyf.error(res.data);
    }
  } catch (error) {
    alert("パスワードの変更に失敗しました");
    console.log(error);
  }
};

// let mailAddress = ref("");
let passwordData = ref({
  // kariPassword: "",
  currentPassword: "",
  newPassword: "",
  newSubPassword: "",
});
const passInput = (e: string, key: keyof PasswordData) => {
  passwordData.value[key] = e;
};

let hasError = ref(false);
let errorMessage = reactive({
  // email: "",
  // kariPassword: "",
  newPassword: "",
  newSubPassword: "",
});
const validateError = () => {
  hasError.value = false;
  errorMessage.newPassword = "";
  errorMessage.newSubPassword = "";

  if (passwordData.value.newPassword === "") {
    errorMessage.newPassword = "新しいパスワードを入力してください";
    hasError.value = true;
  }
  if (passwordData.value.newSubPassword === "") {
    errorMessage.newSubPassword = "新しいパスワード(確認用)を入力してください";
    hasError.value = true;
  }
  //パスワードは半角英数字、半角記号(_@-/.)
  if (!isValidPassword(passwordData.value.newPassword)) {
    // console.log(isValidPassword(passwordData.value.newPassword));
    errorMessage.newPassword =
      "パスワードは半角英数字、半角記号(_@-/.)8～20桁で入力してください";
    hasError.value = true;
  }
  if (!isValidPassword(passwordData.value.newSubPassword)) {
    // console.log(isValidPassword(passwordData.value.newSubPassword));
    errorMessage.newSubPassword =
      "パスワードは半角英数字、半角記号(_@-/.)8～20桁で入力してください";
    hasError.value = true;
  }
  //確認用パスワードが異なっていたら中断
  if (passwordData.value.newPassword !== passwordData.value.newSubPassword) {
    notyf.error("確認用パスワードが異なっています");
    hasError.value = true;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(InputText, {
            class: "Login_Form_Input",
            placeholder: "新しいパスワード",
            type: "password",
            value: _unref(passwordData).newPassword,
            onOnInput: _cache[0] || (_cache[0] = ($event: any) => (passInput($event, 'newPassword')))
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(errorMessage).newPassword), 1),
          _createVNode(InputText, {
            class: "Login_Form_Input",
            placeholder: "新しいパスワード(確認用)",
            type: "password",
            value: _unref(passwordData).newSubPassword,
            onOnInput: _cache[1] || (_cache[1] = ($event: any) => (passInput($event, 'newSubPassword')))
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(errorMessage).newSubPassword), 1),
          _createVNode(BtnGreen, {
            class: "Login_Form_BtnGreen",
            onClick: resetPassWord
          }, {
            default: _withCtx(() => [
              _createTextVNode("再設定")
            ]),
            _: 1
          }),
          _createElementVNode("p", null, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _createTextVNode("ログイン画面に戻る")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})